import React, { useRef, useState, useEffect } from "react";
import { Button, Form, Row, Col, Spinner } from "react-bootstrap";
import { MdDelete, MdUpload } from "react-icons/md";
import _ from "lodash";
import { v4 as uuid } from "uuid";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import TextInputFormik from "../TextInput/TextInputFormik";

const SelectFileInput = ({ formik, field, label, multiple, accept, save, describe, disabled }) => {
  const fileInput = useRef();
  const [uploadPayload, setUploadPayload] = useState([]);
  const { request, data, errors, requestId } = useApiClient();
  useEffect(() => {
    if (uploadPayload.length) {
      for (let i = 0; i < uploadPayload.length; i += 1) {
        request(apiRoutes.fiscalizacao.arquivos.upload, uploadPayload[i], { requestId: uploadPayload[i].fileTicket });
      }
    }
  }, [request, uploadPayload]);

  const { setValues } = formik;

  useEffect(() => {
    if (data || errors) {
      setValues((curr) => {
        const files = [...curr[field]];
        const file = files.find((item) => item.fileTicket === requestId && item.uploading);

        if (!file) {
          return { ...curr };
        }

        file.uploading = false;
        delete file.file;
        if (errors) {
          file.error = errors.message ?? "Erro ao salvar o arquivo.";
        }

        return { ...curr, [`${field}`]: files };
      });
    }
  }, [setValues, field, data, errors, requestId]);
  function onFileChange(event) {
    event.preventDefault();
    const readFiles = [];
    const queue = event.target.files.length;
    const queueProcessed = () => {
      const files = [...formik.values[field], ...readFiles];
      const { target } = event;
      if (save) {
        for (let i = 0; i < readFiles.length; i += 1) {
          readFiles[i].uploading = !describe;
          readFiles[i].fileTicket = uuid();
        }

        if (!describe) {
          setUploadPayload(readFiles);
        }
      }
      formik.setFieldValue(field, files);
      target.files = new DataTransfer().files;
    };
    for (let index = 0; index < queue; index += 1) {
      const fileReader = new FileReader();
      const file = event.target.files[index];
      fileReader.onload = () => {
        readFiles.push({
          name: file.name,
          type: file.type === "" ? "application/octet-stream" : file.type,
          file: fileReader.result.substring(fileReader.result.indexOf(",") + 1),
          description: "",
        });

        if (readFiles.length === event.target.files.length) {
          queueProcessed();
        }
      };
      fileReader.onerror = () => {
        readFiles.push({
          name: file.name,
          type: file.type,
          file: null,
          error: fileReader.error,
        });

        if (readFiles.length === event.target.files.length) {
          queueProcessed();
        }
      };
      fileReader.readAsDataURL(file);
    }
  }
  return (
    <>
      <Button
        variant="primary"
        size="md"
        className="mr-3"
        disabled={formik.isSubmitting || disabled}
        onClick={() => {
          fileInput.current.click();
        }}
      >
        {label || (multiple ? "Selecionar arquivos" : "Selecionar arquivo")}
      </Button>
      <Form.Control
        type="file"
        id={field}
        name={field}
        style={{ display: "none" }}
        ref={fileInput}
        multiple={multiple}
        accept={accept}
        onChange={(e) => onFileChange(e)}
        isInvalid={formik.touched[field] && formik.errors[field]}
      />
      {formik.errors[field] && <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>}
      <div className="card">
        <ul className="list-group list-group-flush">
          {_.isArray(formik.values[field]) &&
            formik.values[field].map((file, index) => (
              <li className="list-group-item" key={file.fileTicket}>
                <Row>
                  <Form.Group as={Col} sm={12} md={12}>
                    <Col>
                      {file.name}
                      {describe && !file.uploading && file.file && (
                        <Button
                          variant="bg-transparent"
                          onClick={() => {
                            const f = file;
                            f.uploading = true;
                            setUploadPayload([file]);
                          }}
                        >
                          <MdUpload className="text-success pa-0 p-0 btn-lg btn-bg-transparent" title="Upload" />
                        </Button>
                      )}
                      {!file.uploading && (
                        <Button
                          variant="bg-transparent"
                          onClick={() => {
                            const updatedArray = [...formik.values[field]];
                            updatedArray.splice(index, 1);
                            formik.setFieldValue(field, updatedArray);
                          }}
                        >
                          <MdDelete className="text-danger pa-0 p-0 btn-lg btn-bg-transparent" title="Excluir" />
                        </Button>
                      )}
                    </Col>
                    {describe && !file.file && <Col>{file.description}</Col>}
                    {describe && file.file && !file.uploading ? (
                      <Col>
                        <TextInputFormik
                          formik={formik}
                          field={`${field}[${index}].description`}
                          placeholder="Digite uma descrição para o anexo"
                        />
                      </Col>
                    ) : null}
                  </Form.Group>
                </Row>
                {file.uploading && (
                  <Row>
                    <Col>
                      <span>
                        &nbsp; &nbsp;
                        <Spinner animation="border" role="status" size="sm" />
                      </span>
                      {file.error && <span style={{ color: "red", fontSize: "smaller" }}>{file.error}</span>}
                    </Col>
                  </Row>
                )}
              </li>
            ))}
        </ul>
      </div>
    </>
  );
};
export default SelectFileInput;
